import Styles from './1.manual/3.school/backCaution/styles.module.css';
import React, { useEffect, useReducer } from 'react';

// 未保存の編集がある画面から離脱しようとしたときの共通ガード。
//
// react-router-dom v7 でも <BrowserRouter>(コンポーネント版ルーター)では
// useBlocker が使えない(data router 必須)。アプリ全体を data router へ
// 移行するのは影響範囲が大きいため、モジュールシングルトンで実装している。
// 同時にマウントされる編集画面は1つだけなのでグローバルな状態で問題ない。
//
// 使い方:
//   - 編集画面: unsavedGuard.setDirty(未保存か) を effect で同期、
//     アンマウント時に setDirty(false)。画面内の遷移は
//     unsavedGuard.request(() => navigate(...)) 経由にする。
//   - サイドバー等の遷移導線: クリックを onClickCapture で拾い、
//     unsavedGuard.request(...) が true(=保留した)を返したら
//     preventDefault + stopPropagation する。
//   - シェルのどこかに <UnsavedGuardModal /> を1つ置く。

let dirty = false;
let pendingRun: (() => void) | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export const unsavedGuard = {
  setDirty(v: boolean) {
    dirty = v;
  },
  isDirty() {
    return dirty;
  },
  // 未保存なら run を保留して確認モーダルを出す(true を返す)。
  // 保存済みなら run をそのまま実行する(false を返す)。
  request(run: () => void): boolean {
    if (!dirty) {
      run();
      return false;
    }
    pendingRun = run;
    emit();
    return true;
  },
  // モーダル用(内部)
  getPending() {
    return pendingRun;
  },
  resolve(leave: boolean) {
    const run = pendingRun;
    pendingRun = null;
    if (leave) dirty = false;
    emit();
    if (leave && run) run();
  },
  subscribe(l: () => void) {
    listeners.add(l);
    return () => {
      listeners.delete(l);
    };
  },
};

// 文言・見た目は 1.manual/3.school・3.recruit の backCaution と統一。
export const UnsavedGuardModal: React.FC = () => {
  const [, force] = useReducer((x: number) => x + 1, 0);
  useEffect(() => unsavedGuard.subscribe(force), []);

  if (!unsavedGuard.getPending()) return null;

  return (
    <div className={Styles.overlay}>
      <div className={Styles.scrim} onClick={() => unsavedGuard.resolve(false)}></div>
      <div className={Styles.card}>
        <h4 className={Styles.title}>編集箇所が保存されていません。</h4>
        <p className={Styles.lead}>
          保存せずに画面を終了した場合、編集記録は残りませんので今一度ご確認ください。
        </p>
        <div className={Styles.actions}>
          <button type="button" className={Styles.btnGhost} onClick={() => unsavedGuard.resolve(true)}>保存しない</button>
          <button type="button" className={Styles.btnPrimary} onClick={() => unsavedGuard.resolve(false)}>戻る</button>
        </div>
      </div>
    </div>
  );
};
